import Drawer from '@mui/material/Drawer'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Box, { BoxProps } from '@mui/material/Box'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import Close from 'mdi-material-ui/Close'
import { v4 as uuidv4 } from 'uuid';
import { client } from 'src/utils/axios-client'
import { ProblemDetails } from 'src/types/ApiErrorResponse'
import { Button, IconButton, Tooltip } from '@mui/material'
import ActivityForm from './ActivityForm'
import * as yup from 'yup'
import { useEffect } from 'react'
import { LeadActivity } from 'src/stores/LeadStore'
import { ActivityScreenStore } from 'src/stores/LeadStore';

import { LeadActivityStore } from 'src/stores/LeadStore'
import _ from 'lodash'
import { getActivityEndpoint, leadEndpoints, getLeadEndpoint } from 'src/configs/endpoints'
import { date } from 'yup/lib/locale'
import { LeadListStore } from 'src/stores/LeadStore'


const Header = styled(Box)<BoxProps>(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3, 4),
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.default
}))

const schema = yup.object().shape({
    //firstName: yup.string().required(),
    //lastName: yup.string().required(),
    //emailAddress: yup.string().required(),
    //jobTitle: yup.string().required(),
    //industry: yup.object().shape({ id: yup.string().required() }),      
    //country: yup.object().shape({ id: yup.string().required() }),
});

export type DiscoveryCallAttendees = {
    id: string,
    fullName: string,
    email: string,
    jobTitle: string
};


const defaultValues = {
    id: uuidv4(),
    leadId: '',
    created: '',
    createdBy: '',
    currentActivity: {
        id: '',
        name: '',
        icon: 'none'
    }, 
    currentActivityOwnerName: '',
    currentActivityDate: new Date().toISOString(),
    currentActivityOutcome: {
        id: '',
        name: '',
        icon: '',
        isMeaningfull: false,
        buttonColor: ''
    }, 
    sprintName: '',
    currentCadenceStep: '',
    currentCadenceName: '',
    currentStage: {
        id: '',
        name: '',
        stageColor: ''
    }, 
    nextStage: {
        id: '',
        name: '',
        stageColor: ''
    }, 
    nextActivity: {
        id: '',
        name: '',
        icon: 'none'
    }, 
    nextActivityDate: new Date().toISOString(),
    nextCadenceStep: '',
    nextCadenceName: '',
    notes: '',
    callSid: '',
    callCost: '',
    callStartTime: new Date().toISOString(),
    durationSeconds: '',
    callStatus: '',
    phoneTo: '',
    phoneFrom: '',
    recording: '',
    recordingSid: '',
    emailFrom: '',
    emailTo: '',
    emailCC: '',
    emailSubject: '',
    emailBody: '',
    socialMediaUsername: '',
    socialMediaPlatform: '',
    isAction: false,
    actionActivityName: '',
    taskOwnerName: '',
    taskDueDate: new Date().toISOString(),
    taskDetails: '',
    taskStatusName: '',
    taskCreatedByName: '',
    taskStatusColor: '',
    noteDetails: '',
    newOwnerName: '',
    newSprintName: '',
    newCedenceName: '',
    newActivityName: '',
    discoveryCallAttendees: [] as DiscoveryCallAttendees[],
    currentActivitySubOutcomeName: '',
    currentActivitySubOutcomeColor: '',
    actionActivityDate: new Date().toISOString(),
    referralToLeadName: '',
    referralToLeadId: '',
    referralFromLeadName: '',
    referralFromLeadId: ''
}


const EditActivityView = () => {
    const leadActivity = ActivityScreenStore.useState(s => s.selectedActivity) as LeadActivity;
    const openActivity = ActivityScreenStore.useState(s => s.openActivity);

    const {
        reset,
        control,
        setError,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: defaultValues,
        mode: 'onChange',
        resolver: yupResolver(schema)
    })

    // Reset form values when activity changes
    useEffect(() => {
        if (!openActivity) {
            reset(defaultValues);
            return;
        }
        if (leadActivity) reset(leadActivity);
        if (!leadActivity) reset(defaultValues);
    }, [openActivity, leadActivity])

    const onSubmit = async (data: LeadActivity) => {
        await client.post(leadEndpoints.updateActivityEndpoint, data)
            .then(async (response) => {
                ActivityScreenStore.update(s => {
                    s.openActivity = false;
                });

                const updatedActivityResposne = await client.get(getActivityEndpoint.replace("{id}", data.id));

                LeadActivityStore.update(s => {
                    const list = _.cloneDeep(s.items);
                    const activityIndex = list.findIndex(s => s.id == data.id);
                    //list.splice(activityIndex, 1)
                    const existingActivity = list[activityIndex];
                    list[activityIndex] = { ...existingActivity, ...updatedActivityResposne.data };
                    s.items = list;
                });

                const updatedLeadResposne = await client.get(getLeadEndpoint.replace("{id}", data.leadId));

                LeadListStore.update(s => {
                    const list = _.cloneDeep(s.list);
                    const leadIndex = list.items.findIndex(s => s.id == data.leadId);
                    const existingLead = list.items[leadIndex];
                    list.items[leadIndex] = { ...existingLead, ...updatedLeadResposne.data };
                    s.list = list;
                });

                reset()
            }).catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        var errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\'
                        });
                    }
                }
            });
    }


    const handleClose = () => {
        ActivityScreenStore.update(s => {
            s.openActivity = false;
        });

        defaultValues.id = uuidv4();
        reset(defaultValues)
    }
    if (!openActivity) return null;

    return <Drawer
        open={openActivity}
        anchor='right'
        variant='temporary'
        onClose={handleClose}
        ModalProps={{ keepMounted: true }}
        sx={{ '& .MuiDrawer-paper': { width: { xs: 300, sm: 800 } } }}
    >
        <Header>
            <Typography variant='h6'>Edit Activity Outcome</Typography>

            <Close fontSize='small' onClick={handleClose} sx={{ cursor: 'pointer' }} />
        </Header>

        {leadActivity && <ActivityForm onSubmit={handleSubmit(onSubmit)} handleClose={handleClose} control={control} errors={errors} activity={leadActivity} />}
    </Drawer>
}

export { EditActivityView }
export default EditActivityView;